export function isAnchor(href: string): boolean {
	return (
		href.startsWith('#') ||
		href.startsWith('http://#') ||
		href.startsWith('https://#')
	)
}

export function extractAnchor(href: string): string | null {
	const match = href.match(/(#.+)$/)

	return match ? match[1] : null
}
